// Normalize a pasted blob of 2FA backup codes into one code per line.
//
// Services present backup codes as grids — several columns per line separated
// by spaces or tabs, sometimes already line-broken. Backup codes never contain
// internal whitespace, so splitting on any run of whitespace and rejoining with
// newlines reliably yields one code per line. Pure and idempotent. Never logs.

export function normalizeBackupCodes(text) {
  if (typeof text !== 'string') return '';
  return text.split(/\s+/).filter(Boolean).join('\n');
}
